<template>
  <span class="user-achievements-list">
    <template v-for="(achievementId) in userAchievements">
      <span
        v-if="!!achievementById(achievementId)"
        :key="achievementId"
      >
        <template
          v-if="achievementById(achievementId).name === 'quality-mark'"
        >
          <v-tooltip
            top
            color="primary"
            :open-on-hover="false"
            content-class="achievement-tootlip"
            v-model="tooltipIsShown['quality-mark']"
          >
            <template v-slot:activator="{ on: {} }">
              <v-img
                class="cursor-pointer"
                :src="require('@/assets/images/ui/quality-mark-icon.png')"
                :max-width="$mediaQuery.isExtraSmall ? 22 : 20"
                contain
                @click.prevent.stop="$mediaQuery.tabletsAndDown ? handleAchievementClick(achievementId) : null"
                @mouseover="!$mediaQuery.tabletsAndDown ? handleAchievementHover(achievementId) : null"
                @mouseout="!$mediaQuery.tabletsAndDown ? handleAchievementMouseOut(achievementId) : null"
              />
            </template>
            <span>
              This professional has achieved excellent quality reviews from Riverflex.<br>
              Click
              <router-link
                class="secondary--text"
                to="/faq/quality-mark"
              >
                here
              </router-link> for more information
              <v-btn
                class="close-tooltip-btn"
                small
                fab
                icon
                @click.prevent.stop="handleAchievementClose(achievementId)"
              >
                <v-icon color="grey">
                  close
                </v-icon>
              </v-btn>
            </span>
          </v-tooltip>
        </template>
      </span>
    </template>
  </span>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import LoadingProgress from '@/components/core/LoadingProgress.vue'
import { IAchievement } from '@/types/models/achievement.model'
import { IOption } from '@/types/form'
import { IUser } from '@/types/models/user.model'

@Component({
  components: {
    LoadingProgress
  },
  computed: {
    ...mapGetters(['achievements', 'achievementById'])
  }
})
export default class UserAchievements extends Vue {
  @Prop() user: IUser

  // data
  tooltipIsShown: any = {
    'quality-mark': false
  }
  tooltipCloseTimeout: any

  // computed
  achievements: IAchievement[]
  achievementById: (id: number) => IAchievement|undefined

  get userAchievements (): number[] {
    return this.user?.achievements || []
  }

  // methods
  async handleAchievementClick (achievementId: number) {
    this.toggleAchievementTooltip(achievementId)
  }

  handleAchievementHover (achievementId: number) {
    clearTimeout(this.tooltipCloseTimeout)
    this.toggleAchievementTooltip(achievementId, true)
  }

  handleAchievementMouseOut (achievementId: number) {
    this.tooltipCloseTimeout = setTimeout(() => {
      this.toggleAchievementTooltip(achievementId, false)
    }, 2000)
  }

  handleAchievementClose (achievementId: number) {
    this.toggleAchievementTooltip(achievementId, false)
  }

  private toggleAchievementTooltip (achievementId: number, toggle?: boolean): IAchievement|undefined {
    const achievemnt = this.achievementById(achievementId)
    if (!achievemnt) return
    this.tooltipIsShown[achievemnt.name] = toggle == undefined ? !this.tooltipIsShown[achievemnt.name] : toggle
    return achievemnt
  }
}
</script>
<style lang="scss" scoped>
.user-achievements-list {
  display: inline-block;
  vertical-align: middle;
}
.achievement-tootlip {
  opacity: 1 !important;
  z-index: 200 !important;
  padding: 10px 40px 10px 10px;
  text-align: center;
  &.v-tooltip__content {
    pointer-events: all;
  }
}
.close-tooltip-btn {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
